<template>
  <div>Acesso Negado</div>
</template>
<script>
export default {};
</script>